@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources/"

@delegate:ResourceContentHash(-261_244_252)
internal val Res.font.material_symbols_filled: FontResource by lazy {
      FontResource("font:material_symbols_filled", setOf(
        ResourceItem(setOf(), "${MD}font/material_symbols_filled.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_970_981_684)
internal val Res.font.material_symbols_outlined: FontResource by lazy {
      FontResource("font:material_symbols_outlined", setOf(
        ResourceItem(setOf(), "${MD}font/material_symbols_outlined.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_023_465_942)
internal val Res.font.public_sans: FontResource by lazy {
      FontResource("font:public_sans", setOf(
        ResourceItem(setOf(), "${MD}font/public_sans.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_648_895_755)
internal val Res.font.vazirmatn: FontResource by lazy {
      FontResource("font:vazirmatn", setOf(
        ResourceItem(setOf(), "${MD}font/vazirmatn.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("material_symbols_filled", Res.font.material_symbols_filled)
  map.put("material_symbols_outlined", Res.font.material_symbols_outlined)
  map.put("public_sans", Res.font.public_sans)
  map.put("vazirmatn", Res.font.vazirmatn)
}
